<template>
  <div>
    <a class="mx-3" target="_blank" href="https://t.me/JGNDeFi">
      <i class="fab fa-telegram"></i>
    </a>
    <a class="mx-3" target="_blank" href="https://github.com/JGNDeFi">
      <i class="fab fa-github"></i>
    </a>
    <a class="mx-3" target="_blank" href="https://medium.com/juggernaut-defi">
      <i class="fab fa-medium"></i>
    </a>
    <a class="mx-3" target="_blank" href="https://twitter.com/JGNDeFi">
      <i class="fab fa-twitter"></i>
    </a>
  </div>
</template>

<script>
import bus from '@/bus.js'
export default {
  name: 'headerLink',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    triggerWechatQrcode(){
      bus.headervue.status_show_qrcode_wechat = true
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>